// import React, { useEffect, useState } from "react";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";

// // Function to convert Google Drive link to direct view link
// const convertDriveLink = (link) => {
//   const match = link.match(/\/d\/([^/]+)\//);
//   if (match && match[1]) {
//     return `https://drive.google.com/uc?export=view&id=${match[1]}`;
//   }
//   return link;
// };

// // Function to check if an image is accessible
// const checkImage = (url) => {
//   return new Promise((resolve) => {
//     const img = new Image();
//     img.onload = () => resolve(true);
//     img.onerror = () => resolve(false);
//     img.src = url;
//   });
// };

// const GcamImageMapTab = () => {
//   const [images, setImages] = useState([]);

//   useEffect(() => {
//     fetch("/gcamImages.json")
//       .then((res) => res.json())
//       .then(async (data) => {
//         console.log("Raw JSON data:", data); // ✅ Check if data is loaded

//         // Convert Google Drive links
//         const converted = data.map((item) => ({
//           ...item,
//           url: convertDriveLink(item.url),
//         }));
//         console.log("Converted URLs:", converted); // ✅ Check converted URLs

//         // Validate each image and replace broken ones
//         for (let item of converted) {
//           const isPublic = await checkImage(item.url);
//           if (!isPublic) {
//             console.error(`Google Drive file is not public: ${item.url}`);
//             item.url = "/fallback-image.png"; // Placeholder for failed images
//           }
//         }

//         setImages(converted); // ✅ Set validated images
//       })
//       .catch((err) => console.error("Error loading JSON:", err));
//   }, []);

//   const customIcon = new L.Icon({
//     iconUrl: "https://cdn-icons-png.flaticon.com/512/854/854878.png",
//     iconSize: [32, 32],
//   });

//   return (
//     <MapContainer
//       center={[17.6, 74.2]}
//       zoom={10}
//       style={{ height: "500px", width: "100%" }}
//     >
//       <TileLayer
//         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//         attribution="&copy; OpenStreetMap contributors"
//       />
//       {images.map((img, index) => (
//         <Marker key={index} position={[img.lat, img.lng]} icon={customIcon}>
//           <Popup>
//             <p>Lat: {img.lat}, Lng: {img.lng}</p>
//             <img
//               src={img.url}
//               alt="Field"
//               style={{ width: "200px", height: "auto" }}
//               onError={() =>
//                 console.error(`Image failed to load in popup: ${img.url}`)
//               }
//             />
//           </Popup>
//         </Marker>
//       ))}
//     </MapContainer>
//   );
// };

// export default GcamImageMapTab;
// GcamImageMapTab.jsx
// import React, { useEffect, useState } from "react";
// import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
// import L from "leaflet";
// import "leaflet/dist/leaflet.css";

// // 🔹 Your public Google Drive JSON link (generated by your Apps Script)
// const JSON_URL =
//   "https://drive.google.com/uc?export=download&id=1yzTrNsUQnpxBJlbFOmenDoPp3YpwVBwY";

// // Fix Leaflet marker icon issue
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl:
//     "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
//   iconUrl:
//     "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
//   shadowUrl:
//     "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
// });

// // Optional custom icon
// const customIcon = new L.Icon({
//   iconUrl: "https://cdn-icons-png.flaticon.com/512/854/854878.png",
//   iconSize: [32, 32],
// });

// export default function GcamImageMapTab() {
//   const [images, setImages] = useState([]);

//   useEffect(() => {
//     fetch(JSON_URL)
//       .then((res) => res.json())
//       .then((data) => {
//         console.log("📦 Loaded JSON:", data);
//         setImages(data);
//       })
//       .catch((err) => console.error("❌ Error loading JSON:", err));
//   }, []);

//   return (
//     <MapContainer
//       center={[17.6, 74.2]}
//       zoom={10}
//       style={{ height: "500px", width: "100%" }}
//     >
//       <TileLayer
//         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//         attribution="&copy; OpenStreetMap contributors"
//       />

//       {images.map((img, index) => (
//         <Marker key={index} position={[img.lat, img.lng]} icon={customIcon}>
//           <Popup>
//             <p>Lat: {img.lat}, Lng: {img.lng}</p>
//             <img
//               src={img.url}
//               alt="Field"
//               style={{ width: "200px", height: "auto" }}
//               onError={(e) => {
//                 console.warn(`⚠️ Image failed to load: ${img.url}`);
//                 e.target.src = "/fallback-image.png";
//               }}
//             />
//           </Popup>
//         </Marker>
//       ))}
//     </MapContainer>
//   );
// }


// GcamImageMapTab.jsx
// GcamImageMapTab.jsx
import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Custom icon for map markers
const customIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/854/854878.png",
  iconSize: [32, 32],
  iconAnchor: [16, 32], // Point of the icon which will correspond to marker's location
  popupAnchor: [0, -32], // Point from which the popup should open relative to the iconAnchor
});

// 🔹 More accurate Maharashtra bounds
const MAHARASHTRA_BOUNDS = [
  [15.6, 72.6], // Southwest corner
  [22.0, 80.9], // Northeast corner
];

// Maharashtra center coordinates
const MAHARASHTRA_CENTER = [19.7515, 75.7139];

// 🔹 Helper: Fit all markers in view but restrict to Maharashtra
function FitBounds({ markers }) {
  const map = useMap();

  useEffect(() => {
    if (markers.length > 0) {
      // Filter markers to only show those within Maharashtra bounds
      const maharashtraMarkers = markers.filter(
        (m) =>
          m.lat >= MAHARASHTRA_BOUNDS[0][0] &&
          m.lat <= MAHARASHTRA_BOUNDS[1][0] &&
          m.lng >= MAHARASHTRA_BOUNDS[0][1] &&
          m.lng <= MAHARASHTRA_BOUNDS[1][1]
      );

      if (maharashtraMarkers.length > 0) {
        const bounds = L.latLngBounds(maharashtraMarkers.map((m) => [m.lat, m.lng]));
        // Ensure bounds don't exceed Maharashtra
        const clampedBounds = L.latLngBounds(
          [
            Math.max(bounds.getSouth(), MAHARASHTRA_BOUNDS[0][0]),
            Math.max(bounds.getWest(), MAHARASHTRA_BOUNDS[0][1])
          ],
          [
            Math.min(bounds.getNorth(), MAHARASHTRA_BOUNDS[1][0]),
            Math.min(bounds.getEast(), MAHARASHTRA_BOUNDS[1][1])
          ]
        );
        map.fitBounds(clampedBounds, { padding: [20, 20] });
      } else {
        map.setView(MAHARASHTRA_CENTER, 7);
      }
    } else {
      map.setView(MAHARASHTRA_CENTER, 7);
    }
  }, [markers, map]);

  return null;
}

// 🔹 Helper function to group nearby markers
function groupNearbyMarkers(markers, threshold = 0.01) {
  const groups = [];
  const processed = new Set();

  markers.forEach((marker, index) => {
    if (processed.has(index)) return;

    const group = [marker];
    processed.add(index);

    // Find nearby markers
    markers.forEach((otherMarker, otherIndex) => {
      if (processed.has(otherIndex) || index === otherIndex) return;

      const distance = Math.sqrt(
        Math.pow(marker.lat - otherMarker.lat, 2) +
        Math.pow(marker.lng - otherMarker.lng, 2)
      );

      if (distance < threshold) {
        group.push(otherMarker);
        processed.add(otherIndex);
      }
    });

    groups.push(group);
  });

  return groups;
}

export default function GcamImageMapTab() {
  const [markers, setMarkers] = useState([]);
  const [markerGroups, setMarkerGroups] = useState([]);

  useEffect(() => {
    fetch("/gps.json")
      .then((res) => res.json())
      .then((data) => {
        console.log("📦 Loaded markers:", data);
        
        // Filter markers to only include those within Maharashtra
        const maharashtraMarkers = data.filter(
          (m) =>
            m.lat >= MAHARASHTRA_BOUNDS[0][0] &&
            m.lat <= MAHARASHTRA_BOUNDS[1][0] &&
            m.lng >= MAHARASHTRA_BOUNDS[0][1] &&
            m.lng <= MAHARASHTRA_BOUNDS[1][1]
        );

        setMarkers(maharashtraMarkers);
        
        // Group nearby markers to handle overlapping
        const groups = groupNearbyMarkers(maharashtraMarkers, 0.005); // Adjust threshold as needed
        setMarkerGroups(groups);
      })
      .catch((err) => console.error("❌ Error loading gps.json:", err));
  }, []);

  const handleMarkerClick = (lat, lng) => {
    const map = window._leaflet_map;
    if (map) {
      // Auto zoom to level 15 for better detail view
      map.setView([lat, lng], 15, { animate: true, duration: 1 });
    }
  };

  return (
    <MapContainer
      center={MAHARASHTRA_CENTER}
      zoom={7}
      style={{ height: "500px", width: "100%" }}
      whenCreated={(mapInstance) => {
        window._leaflet_map = mapInstance;
        // Set strict bounds for Maharashtra
        mapInstance.setMaxBounds(MAHARASHTRA_BOUNDS);
      }}
      maxBounds={MAHARASHTRA_BOUNDS}
      maxBoundsViscosity={1.0}
      minZoom={6} // Prevent zooming out too much
      maxZoom={18} // Allow detailed zoom
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />

      <FitBounds markers={markers} />

      {markerGroups.map((group, groupIndex) => {
        // Calculate center point for the group
        const centerLat = group.reduce((sum, m) => sum + m.lat, 0) / group.length;
        const centerLng = group.reduce((sum, m) => sum + m.lng, 0) / group.length;

        return (
          <Marker
            key={groupIndex}
            position={[centerLat, centerLng]}
            icon={customIcon}
            eventHandlers={{
              click: () => handleMarkerClick(centerLat, centerLng),
            }}
          >
            <Popup maxWidth={300} maxHeight={400}>
              <div style={{ maxHeight: "350px", overflowY: "auto" }}>
                {group.length > 1 && (
                  <p style={{ fontWeight: "bold", color: "#2563eb", marginBottom: "10px" }}>
                    📍 {group.length} locations in this area
                  </p>
                )}
                {group.map((marker, markerIndex) => (
                  <div key={markerIndex} style={{ marginBottom: "15px", borderBottom: group.length > 1 ? "1px solid #e5e5e5" : "none", paddingBottom: "10px" }}>
                    <p>
                      <b>Lat:</b> {marker.lat.toFixed(6)}, <b>Lng:</b> {marker.lng.toFixed(6)}
                    </p>
                    {marker.time && (
                      <p><b>Time:</b> {marker.time}</p>
                    )}
                    {marker.url && (
                      <img
                        src={marker.url}
                        alt={`Field location ${markerIndex + 1}`}
                        style={{ 
                          width: "200px", 
                          marginTop: "5px",
                          borderRadius: "4px",
                          border: "1px solid #ddd"
                        }}
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    )}
                  </div>
                ))}
              </div>
            </Popup>
          </Marker>
        );
      })}
    </MapContainer>
  );
}